<div class="dn db-l col-1-l"></div>
<div
  *ngFor="let column of listData"
  class="col-12 flex flex-column pl0 column"
  [ngClass]="{
    'col-12-m col-11-l': listData.length === 1,
    'col-5-m col-4-l': listData.length === 2,
    'col-4-m col-3-l': listData.length === 3,
    'column-subheader': column.subSection[0].subHeader,
    'no-subheader': !column.subSection[0].subHeader
  }"
>
  <div
    *ngFor="let row of column.subSection"
    [ngClass]="{
      'no-row-subheader': !columnHasSubheader(row),
      'row-subheader': columnHasSubheader(row)
    }"
  >
    <jb-list-items-group [dataColumn]="row"> </jb-list-items-group>
  </div>
</div>
